<template>
  <div class="content">
    <D3LineChart
      :forDashboard="true"
      :statMode="statMode"
      :seriesData="seriesData"
      :series="series"
      @updateStatMode="updateStatMode"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import D3LineChart from '@/components/graphics/D3LineChart.vue';
import { seriesChartOptions } from '../../../components/graphics/chartOptions';

export default {
    name: 'GraphicLineChart',
    components: {
        D3LineChart,
    },
    props: {
        graphicId: {
            type: String,
            default: null,
        },
        series: {
            type: Array,
            default: null,
        },
        statMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            seriesData: [],
            seriesZoomArea: [],
            loading: false,
            seriesChartOptions: null,
        };
    },
    computed: {
        ...mapGetters([
            'lang',
            'getSeries',
        ]),
    },
    async created() {
        this.setOptionChartId();
        this.setSeriesData();
    },
    methods: {
        setOptionChartId() {
            const chartOptionId = `chartOption-${this.graphicId}`;
            this.seriesChartOptions = seriesChartOptions(chartOptionId);
        },
        formattingSerie(data) {
            return data.map(({ date: x, value: y, norm }) => ({
                x,
                y: parseFloat(y),
                norm: norm ? `Min:${norm.minimum} Max:${norm.maximum}` : null,
            }));
        },
        formattingSeries(series, componentNameRef) {
            return series.map(({ analysisType: { name }, data }, index) => ({
                name: `${name[this.lang]}-${componentNameRef[index]}`,
                data: data.map(d => ({
                    ...d,
                    date: new Date(d.measuredAt),
                    value: +d.value,
                })),
            }));
        },
        async setSeriesData() {
            this.loading = true;
            try {
                const componentNameArr = this.series.map(graphRef => graphRef.component.name);
                this.seriesChartOptions = { ...this.seriesChartOptions };
                this.seriesData = this.formattingSeries(this.series, componentNameArr);
                this.loading = false;
            } catch (err) {
                return err;
            }
            return null;
        },
        updateStatMode() {
            this.$emit('updateStatMode', this.statMode);
        },
    },
};
</script>

<style scoped lang="scss">
    .content {
        height: 100%;
        width: 100%;
        padding: 6px 12px;
    }
</style>
